exports = module.exports = require("../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wrapper {\n  display: table !important;\n  width: 100%; }\n\n.wrapper .left,\n.wrapper .left > *,\n.wrapper .right,\n.wrapper .right > * {\n  display: table-cell !important;\n  vertical-align: middle !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/VerticalCenterWrapper/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/VerticalCenterWrapper/index.css
// module chunks = 504